import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

function loadView(view) {
  return () => import(`@/views/${view}.vue`);
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: loadView("Home"),
      alias: "/home"
    },
    {
      path: "/commissions-setup",
      name: "Setup Commisisons",
      component: loadView("commissions-setup")
    },
    {
      path: "/list-partners",
      name: "list partners",
      component: loadView("list-partners")
    },

    {
      path: "/list-commissions",
      name: "List Commisisons",
      component: loadView("list-commissions")
    },

    {
      path: "/commissions-suppressed",
      name: "Suppress Commisisons",
      component: loadView("commissions-suppressed")
    },
    {
      path: "/callback",
      name: "callback",
      component: loadView("Callback")
    },
    {
      path: "/login",
      name: "login",
      component: loadView("Login")
    },
    {
      path: "/partner-details",
      name: "Partner Details",
      component: loadView("partner-details")
    },
    {
      path: "/import-payment",
      name: "Import Payment",
      component: loadView("import-payment")
    },
    {
      path: "/commissions-review",
      name: "Commissions Review",
      component: loadView("commissions-review")
    },
    {
      path: "/commissions-reports",
      name: "Commissions Reports",
      component: loadView("commissions-reports")
    },
    {
      path: "/commissions-rules",
      name: "Commisisons Rules",
      component: loadView("commissions-rules")
    },
    {
      path: "/points-management-report-eligible",
      name: "Qantas Eligible Customers",
      component: loadView("points-management-report-eligible")
    },
    {
      path: "/points-management-report-paid",
      name: "Qantas Paid Customers",
      component: loadView("points-management-report-paid")
    },
    {
      path: "/points-management-report-sent",
      name: "Qantas Transmitted Records",
      component: loadView("points-management-report-sent")
    },
    {
      path: "/qantas-manage-points",
      name: "Manage Points",
      component: loadView("qantas-manage-points")
    },
    {
      path: "/qantas-manage-deleted-records",
      name: "Manage Deleted Records",
      component: loadView("qantas-manage-deleted-records")
    },
    {
      path: "/qantas-add-manual-points",
      name: "Add Manual Points",
      component: loadView("qantas-add-manual-points")
    },
    {
      path: "/previous-payments",
      name: "Review Previous Payments",
      component: loadView("previous-payments")
    },
    {
      path: "/view-clawbacks",
      name: "View Clawbacks",
      component: loadView("view-clawbacks")
    }
  ]
});